import React from "react";
import { Button } from "react-bootstrap";
import EnquiryFormHeader from "./Header";

import css from "./EnquiryForm.module.scss";


function formatDate(dateString: string): string {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
    });
}

function ChatInvintation({
    isLegacy,
    supplierId,
    categoryId,
    supplierName,
    messageDate,
    disabled = false,
}: {
    isLegacy: boolean;
    supplierName: string;
    messageDate: string;
    supplierId: number;
    categoryId: number;
    disabled: boolean;
}) {
    const messageDatestring = messageDate ? `You ${isLegacy ? 'email': 'messaged'} that supplier on ${formatDate(messageDate)}` : '';
    return <div className={`${css.smallDialog} d-flex flex-column align-items-stretch justify-content-center`}> 
        <EnquiryFormHeader supplierName={supplierName} isSupplierMessaging />
        {messageDatestring && <input value={messageDatestring} className={`${css.fakeInput} mt-3`} disabled/> }
        {disabled && (
            <div className={`${css.disabledWarning} mt-2`}>
                Confirm your email address to view conversations. Check your email inbox for instructions.
            </div>
        )}
        <Button variant="primary" className="mt-2" size="sm" disabled={disabled} onClick={() => {
            document.location.href = `/inbox/?supplierId=${supplierId}&categoryId=${categoryId}`;
        }
        }>
            {isLegacy ? 'Start a Chat' : 'View Conversation'}
        </Button>
    </div>
}

export default ChatInvintation;